/** Stable bridge so Mention nodeViews can call the latest navigation handler without recreating extensions. */
export const mentionClickBridge = {
  current: (_id: string) => {},
};
